import saveConfiguration from '../api/SaveConfiguration';
import DownloadSummaryPdf from '../function/DownloadSummaryPdf';

const HandleSave = async ({
  drawing,
  inputs,
  options,
  result,
  setLaunchId,
  setIsLoading,
  showNotification,
  hideNotification,
  priceValue,
  machineSummary,
}) => {
  const name = drawing ? 'drawing' : 'basic';
  const isBudgetPricing = !!inputs.crm_info?.budget;

  setIsLoading((prev) => ({ ...prev, [name]: true }));

  const handleDownloadPdf = () => {
    DownloadSummaryPdf({
      inputs,
      result,
      machineSummary,
      priceValue,
      options,
    });
  };

  try {
    const response = await saveConfiguration(inputs, options, result, drawing);
    const { data } = response;

    const messages = [];

    if (isBudgetPricing) {
      if (!data.crm_saved) {
        messages.push(
          '✅ Configuration is saved. 🔌❌ Data is not connected to CRM.'
        );
      } else {
        messages.push('Budget pricing saved (CRM update was not expected).');
      }
    } else {
      if (!data.crm_saved) {
        messages.push('❌ Configuration was NOT saved to CRM.');
      } else {
        messages.push('✅ Configuration successfully saved and sent to CRM.');
      }
    }

    if (drawing) {
      messages.push(
        '✅ Drawing will be sent by email within a few minutes. ⏳'
      );
    }

    if (data.crm_saved) {
      messages.push(
        'You can return to CRM to finalize your quote and access full specifications. 🏁'
      );
    }

    let notificationType = 'success';
    if (!isBudgetPricing && !data.crm_saved) {
      notificationType = 'error';
    }
    if (isBudgetPricing && !data.crm_saved) {
      notificationType = 'success';
    }

    const extraButtons = [];
    if (isBudgetPricing && !data.crm_saved) {
      extraButtons.push({
        label: 'Return to Entry Screen',
        type: 'return',
        action: () => {
          setLaunchId(null);
          hideNotification();
        },
      });
    }
    extraButtons.push({
      label: 'Download Summary (PDF)',
      type: 'download',
      action: () => {
        handleDownloadPdf();
      },
    });

    showNotification({
      type: notificationType,
      title:
        notificationType === 'error'
          ? 'Save Failed'
          : notificationType === 'warning'
            ? 'Save Completed (with notice)'
            : 'Save Successful',
      message: messages,
      extraButtons,
    });
  } catch (err) {
    showNotification({
      type: 'error',
      title: 'Save Failed',
      message: err.message,
    });
  } finally {
    setIsLoading((prev) => ({ ...prev, [name]: false }));
  }
};

export default HandleSave;
